import React from 'react';
import AvailableIcon from '../shared/components/Icons/Available';
import ElectronicIcon from '../shared/components/Icons/TicketType/Electronic';
import {
  default as PaperIcon,
  default as PreorderIcon,
} from '../shared/components/Icons/TicketType/Paper';
import PreorderCommon from '../shared/components/Icons/TicketType/Preorder';
import SalesIcon from '../shared/components/Icons/TicketType/Sales';

export const STATUS_ICONS_NAMES = {
  AVAILABLE: 'available',
  PREORDER: 'preorder',
};

export const TICKET_TYPES_ICONS = {
  1: ElectronicIcon,
  2: PaperIcon,
};

export const STATUS_ICONS = {
  [STATUS_ICONS_NAMES.AVAILABLE]: <AvailableIcon />,
  [STATUS_ICONS_NAMES.PREORDER]: <PreorderIcon />,
};

export const STATUS_ICONS_COMMON = {
  [STATUS_ICONS_NAMES.AVAILABLE]: <SalesIcon />,
  [STATUS_ICONS_NAMES.PREORDER]: <PreorderCommon />,
};
